import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'


import Field from './Field'

export function DescriptionField({ form, onChange, inputChildren, wrapperClass, disabled = false, label, bothSelected }) {
  const description = form.description ?? ''

  const { t } = useTranslation()


  return (
    <Field
      fieldName="description"
      maxLength={250}
      value={description}
      onChange={onChange}
      disabled={disabled}
      maxLengthClassNamesFn={(length) =>
        length > 0 && length <= 200 ? 'green' : length > 200 && length <= 240 ? 'orange' : length > 240 ? 'red' : ''
      }
      inputChildren={inputChildren}
      wrapperClass={wrapperClass}
      inputClass={'input-autofill'}
      label={label}
      bothSelected={bothSelected}
      tooltip={{
        title: t('Recommendations.campaign.setup.description.title'),
        body: (
          <div style={{ fontSize: '.875rem', fontWeight: 500 }}>
            <p className="pb-1">{t('Tips.Recommendations.CreativeComposer.Description.1')}</p>
          </div>
        ),
      }}
    />
  )
}
DescriptionField.propTypes = {
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  inputChildren: PropTypes.func,
  wrapperClass: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  bothSelected: PropTypes.bool,
}
